import { DialogOverlay, DialogOverlayFooter, DialogOverlayActions, Button, TextField } from '@fs/zion-ui'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { addCmisReference } from '../../../services/personService'
import useNotifications from '../../../hooks/useNotifications'
import { DotSeparator } from '../../metadata/MetaData'
import { isMrn, mrnRemoveDashes } from '../../../util/EntityUtil'
import DmcVerifiedMrnTextField from '../DmcVerifiedMrnTextField'

export default function CmisRefAddDialog({ personDetails, onSubmit, ...opener }) {
  const { error, ok } = useNotifications()
  const [mrn, setMrn] = useState()
  const [personId, setPersonId] = useState()
  const { t } = useTranslation()

  const addButtonDisabled = personDetails ? !mrn || !isMrn(mrn) : !mrn || !personId || !isMrn(mrn)

  useEffect(() => {
    if (!opener.isOpen && !opener.transitioning) {
      setMrn()
      setPersonId()
    }
  }, [opener.isOpen, opener.transitioning])

  const handleAdds = () => {
    addCmisReference(personDetails ? personDetails.copyPersonId : personId, mrnRemoveDashes(mrn))
      .then(() => {
        ok(t('person.cmis.successCreatingCmisReference', 'Success creating CMIS Reference'))
        onSubmit()
      })
      .catch((err) => {
        error(
          t('person.cmis.error.addingCmisReferences', {
            defaultValue: `Error adding a CMIS references: ${err.message || ''}`,
            message: err.message || '',
          }),
          err
        )
      })
  }
  if (!onSubmit) {
    return null
  }

  const onChangeTypeMrn = (event) => {
    setMrn(event.target.value)
  }

  return (
    <DialogOverlay {...opener} title={t('person.reference.addCmisReference', 'Add CMIS Reference')}>
      {personDetails ? (
        <>
          {personDetails.copyPersonName}
          <DotSeparator />
          {personDetails.copyPersonId}
        </>
      ) : (
        <TextField
          title={t('personId', 'Person ID')}
          label={t('personId', 'Person ID')}
          onChange={(e) => setPersonId(e.target.value)}
          value={personId}
        />
      )}
      <DmcVerifiedMrnTextField
        label={t('mrn', 'MRN')}
        value={mrn}
        onChange={onChangeTypeMrn}
        setIsVerifiedMember={() => {}}
      />

      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button id="confirmAddReferenceBtn" emphasis="high" onClick={handleAdds} disabled={addButtonDisabled}>
            {t('action.add', 'Add')}
          </Button>
          <Button emphasis="medium" onClick={opener.close}>
            {t('action.cancel', 'Cancel')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
